<template>
  <section>
    <v-toolbar flat class="main-header px-0 mb-6">
      <v-toolbar-title class="main-header__title">
        <h2 class="heading-counter my-6">
          <span class="counter">2</span>Age Groups
        </h2>
        <p class="text-center" v-if="isEdit">
          Can Be Edited through teams Page
          <router-link
            :to="{
              name: 'CampsTeams',
              params: { id: this.$route.params.id },
            }"
            >here</router-link
          >
        </p>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-toolbar-items v-if="!isEdit" class="main-header__contents">
        <v-btn
          class="button btn-height--1 my-auto mx-1"
          @click="addGroup"
          color="success"
          :disabled="addButtonCheck()"
        >
          <i class="icon-add"></i>
          <span class="mx-2">Add Age Group</span>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <section v-if="!isEdit">
      <v-card class="global-card px-5 mt-10 pt-5">
        <v-card-text>
          <v-row>
            <v-col md="4" sm="6" cols="12">
              <v-select
                @change="teamSpots"
                :items="classifications"
                label="Classification"
                item-text="name"
                item-value="id"
                regular
                clearable
                v-model="groups.classification"
              ></v-select>
            </v-col>
            <v-col md="4" sm="6" cols="12">
              <form-group name="min_grade" attribute="fields.min_grade">
                <template slot-scope="{ attrs, listeners }">
                  <v-select
                    :items="minGrade"
                    item-text="name"
                    item-value="id"
                    regular
                    clearable
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="groups.min_grade.id"
                    @change="updateMinGrade"
                  ></v-select>
                </template>
              </form-group>
            </v-col>
            <v-col md="4" sm="6" cols="12">
              <form-group name="max_grade" attribute="fields.max_grade">
                <template slot-scope="{ attrs, listeners }">
                  <v-select
                    :items="maxGrade"
                    item-text="name"
                    item-value="id"
                    regular
                    clearable
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="groups.max_grade.id"
                    @change="updateMaxGrade"
                  ></v-select>
                </template>
              </form-group>
            </v-col>
            <v-col md="4" sm="6" cols="12">
              <section class="increment-label">
                <span>Min Age</span>
                <number-input
                  center
                  v-model="groups.min_age"
                  :min="0"
                  controls
                  :step="0.01"
                ></number-input>
              </section>
            </v-col>
            <v-col md="4" sm="6" cols="12">
              <section class="increment-label">
                <span>Max Age</span>
                <number-input
                  center
                  v-model="groups.max_age"
                  :min="1"
                  controls
                  :step="0.01"
                ></number-input>
              </section>
            </v-col>
            <v-col md="4" sm="6" cols="12">
              <section class="increment-label">
                <span>Teams</span>
                <number-input
                  center
                  v-model="groups.teams"
                  :step="0.01"
                  :min="groups.teams_per_group || 2"
                  controls
                ></number-input>
              </section>
            </v-col>
            <v-col md="4" sm="6" cols="12">
              <section class="increment-label">
                <span>Teams Per Group</span>
                <number-input
                  center
                  v-model="groups.teams_per_group"
                  :min="1"
                  :step="0.01"
                  controls
                ></number-input>
              </section>
            </v-col>
            <v-col md="4" sm="6" cols="12">
              <section class="increment-label">
                <span>Spots Per Team</span>
                <number-input
                  center
                  v-model="groups.spots_per_team"
                  :min="1"
                  :step="0.01"
                  controls
                  :disabled="dimmedActions"
                ></number-input>
              </section>
            </v-col>
          </v-row>
          <transition name="fade" mode="out-in">
            <!-- v-if="groupsAdded.length > 0" -->
            <v-data-table
              :headers="groupsHeaders"
              :items="groupsAdded"
              hide-default-footer
              :mobile-breakpoint="0"
              :items-per-page="20"
              class="table mt-8"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td class="text-sm-center">{{ item.name }}</td>
                  <td class="text-sm-center">{{ item.min_grade.name }}</td>
                  <td class="text-sm-center">{{ item.max_grade.name }}</td>
                  <td class="text-sm-center">{{ item.min_age }}</td>
                  <td class="text-sm-center">{{ item.max_age }}</td>
                  <td class="text-sm-center">{{ item.teams }}</td>
                  <td class="text-sm-center">{{ item.teams_per_group }}</td>
                  <td class="text-sm-center">{{ item.spots_per_team }}</td>
                  <td class="text-sm-center">
                    <i
                      class="icon-delete delete"
                      @click="handleDelete(item)"
                    ></i>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </transition> </v-card-text
      ></v-card>
    </section>
  </section>
</template>

<script>
import {
  IndexData,
  // StoreData,
  // ShowData,
  // UpdateData
} from "@/helpers/apiMethods";
import TableHeaders from "@/helpers/TableHeaders";

export default {
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    groups: {
      type: Object,
      default: () => {},
    },
    v: {
      type: Object,
      default: () => {},
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    classifications: {
      type: Array,
      default: () => {},
    },
  },
  data() {
    return {
      groupsAdded: [],
      groupsHeaders: [],
      minGrade: [],
      maxGrade: [],
      detailed_classification: {},
      dimmedActions: true,
    };
  },
  created() {
    this.createTableHeaders();
    this.indexGrades();
  },
  methods: {
    indexGrades() {
      IndexData({ reqName: "grades" })
        .then((res) => {
          const { data } = res.data;
          this.minGrade = data;
          this.maxGrade = data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    teamSpots() {
      const classification = this.groups.classification;
      this.classifications.forEach((item) => {
        if (item.id === classification) {
          this.groups.name = item.name;
          this.groups.spots_per_team = item.spots_per_team;
          this.groups.min_age = item.min_age;
          this.groups.max_age = item.max_age;
          this.groups.min_grade = item.min_grade;
          this.groups.max_grade = item.max_grade;
          if (item.spots_per_team === null) {
            this.dimmedActions = false;
          } else {
            this.dimmedActions = true;
          }
        }
      });
    },
    addButtonCheck() {
      if (this.groups.classification === null) {
        return true;
      } else {
        return false;
      }
    },
    createTableHeaders() {
      const headersList = [
        "Classification",
        "Min Grade",
        "Max Grade",
        "Min Age",
        "Max Age",
        "Teams",
        "Teams Per Group",
        "Spots Per Team",
        "Discard",
      ];
      this.groupsHeaders = TableHeaders(headersList);
    },
    addGroup() {
      this.groupsAdded.push(this.groups);
      this.$emit("handle_table_data", this.groupsAdded);
      this.$emit("handle_reset_data");
    },
    updateMinGrade() {
      const min_grade = this.groups.min_grade.id;
      this.minGrade.forEach((item) => {
        if (item.id === min_grade) {
          this.groups.min_grade = item;
        }
      });
    },
    updateMaxGrade() {
      const max_grade = this.groups.max_grade.id;
      this.maxGrade.forEach((item) => {
        if (item.id === max_grade) {
          this.groups.max_grade = item;
        }
      });
    },
    handleDelete(item) {
      const index = this.groupsAdded.indexOf(item);
      this.groupsAdded.splice(index, 1);
    },
  },
};
</script>
